var _rect, _rect2, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlatform(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 64,
    viewBox: "0 0 68 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.248,
    y: 48.8798,
    width: 2.79829,
    height: 12.1259,
    fill: "url(#paint0_linear_45_1408)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.22656,
    y: 3.17438,
    width: 61.7736,
    height: 43.4703,
    stroke: "url(#paint1_linear_45_1408)",
    strokeWidth: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.9204,
    y: 60.0729,
    width: 21.7351,
    height: 3.43187,
    fill: "url(#paint2_linear_45_1408)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_1408",
    x1: 35.0482,
    y1: 48.8798,
    x2: 35.0482,
    y2: 60.3994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4CD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45_1408",
    x1: 65.3867,
    y1: 23.6296,
    x2: 3.22656,
    y2: 23.6296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4CD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_45_1408",
    x1: 22.9204,
    y1: 63.5048,
    x2: 44.6556,
    y2: 63.5048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4CD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2FF29"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatform);
export default __webpack_public_path__ + "static/media/platform.70b0fbd23323ee3b8a2c362097404f18.svg";
export { ForwardRef as ReactComponent };